var map = {
	"./activity.svg": 2432,
	"./alert-triangle.svg": 52348,
	"./align-left.svg": 50752,
	"./archive.svg": 39363,
	"./arrow-down.svg": 31759,
	"./arrow-left.svg": 65648,
	"./arrow-right.svg": 76415,
	"./arrow-up.svg": 46688,
	"./arrow.svg": 57190,
	"./bank.svg": 73209,
	"./bar-chart-2.svg": 55036,
	"./bell.svg": 73516,
	"./book-open.svg": 69429,
	"./box.svg": 2474,
	"./calculate.svg": 50041,
	"./calendar.svg": 85033,
	"./camera.svg": 58854,
	"./card.svg": 94817,
	"./cash.svg": 52442,
	"./check-square.svg": 4723,
	"./check.svg": 82497,
	"./check2.svg": 26721,
	"./chevron-down.svg": 79573,
	"./chevron-down2.svg": 11421,
	"./chevron-right.svg": 19501,
	"./clock.svg": 92075,
	"./close-2.svg": 51452,
	"./close.svg": 35837,
	"./copy.svg": 28552,
	"./corner-down-right.svg": 44692,
	"./credit-card.svg": 48531,
	"./credit.svg": 60552,
	"./creditcheck.svg": 72560,
	"./crop.svg": 76217,
	"./device.svg": 10781,
	"./device2.svg": 59541,
	"./deviceIcon.svg": 60378,
	"./divide.svg": 95004,
	"./download.svg": 91303,
	"./download2.svg": 79047,
	"./drag.svg": 37229,
	"./droplet.svg": 36935,
	"./duplicate.svg": 20430,
	"./dyna.svg": 1309,
	"./dynamic.svg": 43350,
	"./edit-box.svg": 43771,
	"./edit.svg": 975,
	"./euro.svg": 11116,
	"./external-link.svg": 839,
	"./eye-off.svg": 59210,
	"./eye.svg": 34426,
	"./fantasticon/icons.css": 97456,
	"./fantasticon/icons.eot": 47979,
	"./fantasticon/icons.woff": 37459,
	"./fantasticon/icons.woff2": 21291,
	"./film.svg": 31357,
	"./filter.svg": 87985,
	"./gift.svg": 66081,
	"./globe.svg": 5938,
	"./hash.svg": 29607,
	"./heart-empty.svg": 2145,
	"./heart-full.svg": 29349,
	"./heart.svg": 49733,
	"./heart_minus.svg": 10240,
	"./heart_plus.svg": 24232,
	"./home.svg": 74174,
	"./hour-glass-end.svg": 5090,
	"./hour-glass-start.svg": 3217,
	"./image.svg": 83922,
	"./images.svg": 61773,
	"./inbox.svg": 8973,
	"./info.svg": 36947,
	"./integration.svg": 40163,
	"./integration2.svg": 84027,
	"./invoice.svg": 98292,
	"./invoice2.svg": 28110,
	"./invoice3.svg": 40191,
	"./key.svg": 97000,
	"./kiosk-disabled.svg": 22361,
	"./kiosk.svg": 15684,
	"./kitchen.svg": 23993,
	"./kitchen2.svg": 90729,
	"./layers.svg": 63465,
	"./link.svg": 31119,
	"./list.svg": 60071,
	"./lock.svg": 45482,
	"./log-out.svg": 40852,
	"./mail.svg": 59814,
	"./map-pin.svg": 35789,
	"./mapg.svg": 81802,
	"./mapw.svg": 4602,
	"./markpaid.svg": 69878,
	"./menu-bars.svg": 33493,
	"./menu-gray.svg": 39226,
	"./menu-white.svg": 77374,
	"./menu.svg": 72434,
	"./message-circle.svg": 63493,
	"./mimo1.svg": 68130,
	"./mimo2.svg": 39025,
	"./minus.svg": 48441,
	"./monitor.svg": 17871,
	"./more-vertical.svg": 71095,
	"./move.svg": 67680,
	"./package.svg": 9453,
	"./paperclip.svg": 19081,
	"./percent.svg": 87594,
	"./phone.svg": 16345,
	"./picture.svg": 75887,
	"./picture2.svg": 73375,
	"./picture3.svg": 42382,
	"./plus-square.svg": 5777,
	"./plus.svg": 24491,
	"./print-disabled.svg": 30209,
	"./print-enabled.svg": 168,
	"./printer.svg": 89049,
	"./qr.svg": 86690,
	"./refresh.svg": 32304,
	"./robot-ai.svg": 95952,
	"./save.svg": 44660,
	"./scale.svg": 30927,
	"./scan.svg": 30124,
	"./search.svg": 64343,
	"./service.svg": 61712,
	"./service2.svg": 56098,
	"./settings.svg": 20716,
	"./shield.svg": 66164,
	"./shopping-cart.svg": 5302,
	"./shopping_bag.svg": 29076,
	"./statistic.svg": 28195,
	"./table.svg": 1145,
	"./table_bar.svg": 90195,
	"./tablet.svg": 73495,
	"./terminal.svg": 35311,
	"./timer-start.svg": 65161,
	"./transfer.svg": 97422,
	"./trash.svg": 36891,
	"./upload.svg": 50600,
	"./user.svg": 10698,
	"./users.svg": 73557,
	"./warning.svg": 42865,
	"./website-disabled.svg": 15731,
	"./website.svg": 9386,
	"./website2.svg": 91700,
	"./x-circle.svg": 5046,
	"./x.svg": 99897,
	"./zap.svg": 80656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;